var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.repeatData.title,
            visible: _vm.dialogVisible,
            width: _vm.repeatData.width,
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "mt20" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.rules,
                    rules: _vm.rule,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "title" } },
                    [
                      _vm.repeatData.title == "添加类目" ||
                      _vm.repeatData.title == "编辑类目"
                        ? _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [_vm._v("类目名称：")]
                          )
                        : _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.repeatData.label === 1
                                    ? _vm.$t("customer.typename")
                                    : _vm.$t("customer.labelename")
                                ) + "："
                              ),
                            ]
                          ),
                      _vm._v(" "),
                      _vm.repeatData.title == "添加分类"
                        ? _c("el-input", {
                            attrs: {
                              maxlength: "16",
                              "show-word-limit": "",
                              placeholder: "请输入分类名称",
                            },
                            model: {
                              value: _vm.rules.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.rules, "title", $$v)
                              },
                              expression: "rules.title",
                            },
                          })
                        : _c("el-input", {
                            attrs: {
                              maxlength: "16",
                              "show-word-limit": "",
                              placeholder: _vm.placeholderFn(
                                _vm.repeatData.label
                              ),
                            },
                            model: {
                              value: _vm.rules.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.rules, "title", $$v)
                              },
                              expression: "rules.title",
                            },
                          }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _vm._v(_vm._s(_vm.$t("toptable.sort")) + "："),
                      ]),
                      _vm._v(" "),
                      _c("el-input-number", {
                        attrs: {
                          controls: false,
                          min: 0,
                          max: 999999,
                          placeholder: _vm.$t("customer.placeholder04"),
                        },
                        model: {
                          value: _vm.rules.sort,
                          callback: function ($$v) {
                            _vm.$set(_vm.rules, "sort", $$v)
                          },
                          expression: "rules.sort",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleClose } },
                [_vm._v(_vm._s(_vm.$t("public.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    loading: _vm.loading,
                    type: "primary",
                  },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("public.ok")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }